import React from "react";
import About from "../components/about/About";

const AboutPage = () => {
  return (
    <section id="about">
      <About />
    </section>
  );
};

export default AboutPage;
